var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anonymous-layout"},[(_vm.isRouteLoading)?_c('v-progress-linear',{staticStyle:{"z-index":"2000","top":"-97px"},attrs:{"indeterminate":"","color":"cyan"}}):_vm._e(),_c('Header'),_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_vm._t("default")],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }